import { setEnvironmentRequestUri } from '@libs/store';
import { TRequestUri } from '@libs/types';
import { PARENT_ORIGIN_KEY } from '@libs/utils';
import React, { useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router';

export const DeepLinkPage = () => {
    const navigation = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const requestUri = {
            path: location.pathname,
        } as TRequestUri;
        if (searchParams.size !== 0) {
            requestUri.data = Object.fromEntries(searchParams.entries());
        }
        setEnvironmentRequestUri(requestUri);
        const parentOrigin = searchParams.get(PARENT_ORIGIN_KEY);
        if (parentOrigin) {
            sessionStorage.setItem(PARENT_ORIGIN_KEY, parentOrigin);
        }
        navigation('/', { replace: true });
    }, [location.pathname, navigation, searchParams]);

    return <h1>Loading</h1>;
};
